'use strict';

import type { GlobCountyZip } from '../../Entities/Glob/GlobCountyZip';
import { EntityCollection } from '../EntityCollection';

export class GlobCountyZipCollection extends EntityCollection<GlobCountyZip> {}
